




















































import { ref, defineComponent } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import FullResponsePanel from '~/modules/checkout/components/shipping/modal/components/FullResponsePanel.vue';

export default defineComponent({
  components: { SfButton, FullResponsePanel },
  props: {
    downloadLink: {
      type: String,
      default: '',
    },
    fullResponse: {
      type: String,
      default: '',
    },
    field: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const confirmStatus = ref(false);

    const onBackToStore = (field?: string) => {
      emit('backToStore', {
        field,
      });
    };

    const onUseEntered = () => {
      confirmStatus.value = true;
      emit('confirm', { choice: 'entered' });
    };

    return {
      confirmStatus,
      onBackToStore,
      onUseEntered,
    };
  },
});
